import React from "react";
import { CheckCircle } from "@material-ui/icons";

export const AccordianLabel = ({
  label = "Column Details",
  checked = false,
}) => {
  return (
    <div className={`d-flex align-items-center`}>
      <CheckCircle style={{ fill: checked ? "#00B779" : "#D4D3D1" }} />
      <div className={`d-flex align-items-center`}>
        <div className={`ml-2`}>{label}</div>
      </div>
    </div>
  );
};
